export const checkFormulaValidation = (content: string) => {
  const { IsValid } = window.validateRowFormula ? window.validateRowFormula(content) : { IsValid: true };
  return IsValid;
};
